export default class Permissions {
  
  constructor(permissions){
    this.permissions = !permissions ? {}:permissions;
  }

  can = (ability, endpoint) => {
    if (this.permissions.hasOwnProperty(ability)) {
      const endpoints = this.permissions[ability];
      return endpoints.hasOwnProperty(endpoint);
    }
  }
  
  blockedField = (field, endpoint, method="post") => {
    const fields = this.permissions[method];
    if (fields.hasOwnProperty(endpoint)) {
      const { requestGuards } = fields[endpoint];
      return requestGuards.includes(field);
    }
    return true;
  }

  sidebarData = (id) => {
    
    const dashboard = {
      title: false, options: [
        {name: "Home", icon: "Home", path: "/"}
      ]
    }

    const jobs = {
      title: "Jobs", options: [
          {name: "Assigned To You", icon: "FileText", path: "/jobs#assigned_to="+id},
          {name: "Created By You", icon: "File", path: "/jobs#user_id="+id},
          {name: "Add Job", icon: "FilePlus", path: "/dashboard#add"},
      ]
    };
    const analytics = {
      title: "Analytics", options: [
          {name: "Reports", icon: "BarChart2", path: "/reports"}
      ]
    };

    const management = {
      title: "Management", options: [
        {name: "Users", icon: "Users" ,path: "/users"},
        {name: "Job types", icon: "MoreHorizontal", path: "/types"},
        {name: "Locations", icon: "Globe", path: "/locations"}
      ]
    };

    const companies = {
      title: "Companies", options: [
        {name: "List", icon: "File" ,path: "/companies"},
      ]
    };

    const menu = [dashboard];

    if(this.can('post','jobs')) menu.push(jobs);
    if(this.can('get','stats') && this.can('post','users')) menu.push(analytics);
    if(this.can('post','users')) menu.push(management);
    if(this.can('post','companies')) menu.push(companies);
    if(this.can('post','companies')) menu[1].options.splice(0,2,{name: "List", icon: "FileText", path: "/jobs"});
    return menu;
  };


}




// WEBPACK FOOTER //
// ./src/Utilities/Permissions.js